import { render, staticRenderFns } from "./vModalComponent.vue?vue&type=template&id=d89816ae&scoped=true"
import script from "./vModalComponent.vue?vue&type=script&lang=js"
export * from "./vModalComponent.vue?vue&type=script&lang=js"
import style0 from "./vModalComponent.vue?vue&type=style&index=0&id=d89816ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89816ae",
  null
  
)

export default component.exports